import { takeLastSearchFilter } from "./RouteConstants";

export const getLoginRedirectUri = (pathName: string, suffix: string | null = null) => {
    const suffixToAdd = suffix ? suffix : "";
    return `/account/login?redirectUri=${
        process.env.NODE_ENV !== "production"
          ? encodeURI("http://localhost:3000") + pathName + suffixToAdd
          : pathName + suffixToAdd
      }?${takeLastSearchFilter}=${true}`;
}

export const getBookmarksRedirectUri = (currentPath: string) => {
  return `/account/bookmarks?redirectUri=${encodeURIComponent(currentPath)}`;
}